import { apiClient } from './apiClient';

export interface BlockGenerationData {
  [date: string]: {
    [blockId: string]: {
      generation_kwh: number;
      cuf: number;
      is_flatline: boolean;
    };
  };
}

export interface CUFData {
  [date: string]: {
    [blockId: string]: {
      cuf: number;
      is_flatline: boolean;
    };
  };
}

export interface FlatlineDetectionData {
  flatline_blocks: Array<{
    block_id: string;
    generation_kwh: number;
    count: number;
  }>;
  total_flatline_blocks: number;
}

export const blockGenerationService = {
  async getDailyGeneration(plantId?: string, dateRange?: string): Promise<BlockGenerationData> {
    const params = new URLSearchParams();
    if (plantId) params.append('plant_id', plantId);
    if (dateRange) params.append('date_range', dateRange);
    
    const response = await apiClient.get(`/api/monitoring/blocks/test-data/?${params}`);
    return response.data;
  },

  async getFlatlineDetection(): Promise<any> {
    const response = await apiClient.get('/api/monitoring/blocks/flatline-detection/');
    return response.data;
  },

  async getCUFNormalized(plantId?: string, dateRange?: string): Promise<CUFData> {
    const params = new URLSearchParams();
    if (plantId) params.append('plant_id', plantId);
    if (dateRange) params.append('date_range', dateRange);
    
    const response = await apiClient.get(`/api/monitoring/blocks/cuf-normalized/?${params}`);
    return response.data;
  }
};